import { api } from '../api';
import {
  ToolMetadata,
  ToolVersionRevisionNumber,
  ToolRevisionData
} from '../interfaces/Tool.types';

export const urlTool = 'tools';

export const toolApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getToolMetadata: builder.query<ToolMetadata[], void>({
      query: () => ({
        url: `${urlTool}`,
        method: 'GET',
      }),
      providesTags: [urlTool],
    }),

    getToolMetadataById: builder.query<ToolMetadata, { toolId: string }>({
      query: ({ toolId }) => ({
        url: `${urlTool}/${toolId}`,
        method: 'GET',
      }),
      providesTags: [urlTool],
    }),

    getToolVersionRevisions: builder.query<ToolVersionRevisionNumber[], { toolId: string }>({
      query: ({ toolId }) => ({
        url: `${urlTool}/${toolId}/version/revision`,
        method: 'GET',
      }),
      providesTags: [urlTool],
    }),

    getToolRevisionById: builder.query<ToolRevisionData, { toolId: string; version: string; revision: number }>({
      query: ({ toolId, version, revision }) => ({
        url: `${urlTool}/${toolId}/version/${version}/revision/${revision}`,
        method: 'GET',
      }),
      providesTags: [urlTool],
    }),

    createToolRevision: builder.mutation<void, { toolId: string; version: string; data: ToolRevisionData }>({
      query: ({ toolId, version, data }) => ({
        url: `${urlTool}/${toolId}/version/${version}/revision`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [urlTool]
    }),

    updateToolRevisionAssignments: builder.mutation<void, { toolId: string; data: ToolMetadata }>({
      query: ({ toolId, data }) => ({
        url: `${urlTool}/${toolId}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [urlTool]
    }),

    reloadToolsBackend: builder.mutation<void, void>({
      query: () => ({
        url: `${urlTool}/reload`,
        method: 'POST',
      }),
      invalidatesTags: [urlTool]
    }),

    deleteToolVersion: builder.mutation<void, { toolId: string; version: string }>({
      query: ({ toolId, version }) => ({
        url: `${urlTool}/${toolId}/version/${version}`,
        method: 'DELETE',
      }),
      invalidatesTags: [urlTool]
    }),

    deleteTool: builder.mutation<void, { toolId: string }>({
      query: ({ toolId }) => ({
        url: `${urlTool}/${toolId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [urlTool]
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetToolMetadataQuery,
  useGetToolMetadataByIdQuery,
  useGetToolVersionRevisionsQuery,
  useGetToolRevisionByIdQuery,
  useCreateToolRevisionMutation,
  useUpdateToolRevisionAssignmentsMutation,
  useReloadToolsBackendMutation,
  useDeleteToolVersionMutation,
  useDeleteToolMutation,
} = toolApi;
